import { useCallback, useEffect, useState } from 'react'
import { EntityApi } from '@portal/pkg-api/shared'
import { data } from '@portal/pkg-api/helpers'

export type MinimalEntity = {
  id: number
  entityTypeId: number
  shortName?: string
}

export type UseEntityRefSearchProps = {
  entityRefEntityTypeId?: number
}
export type UseEntityRefSearchReturn = {
  options: ReadonlyArray<MinimalEntity>
  onSearchChange: (newSearch: string) => void
}

export function useEntityRefSearch({
  entityRefEntityTypeId,
}: UseEntityRefSearchProps): UseEntityRefSearchReturn {
  const [search, setSearch] = useState('')
  const [options, setOptions] = useState<ReadonlyArray<MinimalEntity>>([])

  useEffect(() => {
    const doSearch = async () => {
      if (!search) {
        setOptions([])
      } else {
        const response = await data(
          EntityApi.getEntityBasicsPaged(
            undefined,
            undefined,
            undefined,
            'shortName',
            search,
            entityRefEntityTypeId ? [entityRefEntityTypeId] : undefined,
            'entityNameAndIdOnly',
            0,
          ),
        )

        setOptions(response.content ?? [])
      }
    }

    void doSearch()
  }, [entityRefEntityTypeId, search])

  const onSearchChange = useCallback((newSearch: string) => {
    setSearch(newSearch)
  }, [])

  return {
    options,
    onSearchChange,
  }
}
